export const isE2e = (): boolean => {
  return !!process.env.REACT_APP_E2E;
};
